// 在没有传props.datas的情况下，用于设置wea-auth中除去第一个select外其他表单字段的默认值
export const getDefaultValues = (datas = []) => {
  let obj = {};
  const getNewObj = d => {
    if (d.conditionType === "SELECT" || d.conditionType === "SELECT_LINKAGE") {
      if (d.options.filter(op => op.selected).length > 0) {
        const select = d.options.filter(op => op.selected)[0];
        obj[d.domkey[0]] = select.key;
        obj[`${d.domkey[0]}span`] = select.showname;
        if (d.conditionType === "SELECT_LINKAGE" && select.key) {
          const sDatas = d.selectLinkageDatas;
          const bDatas = sDatas[select.key];
          bDatas && getNewObj(bDatas);
        }
      }
    } else if (d.conditionType === "CHECKBOX") {
      obj[d.domkey[0]] = d.value || "0";
      obj[`${d.domkey[0]}span`] = d.label || "";
    } else if (d.conditionType === "INPUT") {
      obj[d.domkey[0]] = d.value || "";
    } else if (d.conditionType === "TEXTAREA") {
      obj[d.domkey[0]] = d.value || "";
    } else if (d.conditionType === "DATEPICKER") {
      obj[d.domkey[0]] = d.value || "";
    } else if (d.conditionType === "INPUT_INTERVAL") {
      if (d.value) {
        obj[d.domkey[0]] = d.value[0] || 0;
        obj[d.domkey[1]] = d.value[1] || 100;
        if (d.needDefaultValue === false) {
          obj[d.domkey[0]] = d.value[0];
          obj[d.domkey[1]] = d.value[1];
        }
      }
    } else if (d.conditionType === "RANGEPICKER") {
      if (d.value) {
        obj[d.domkey[0]] = d.value[0];
        obj[d.domkey[1]] = d.value[1];
      }
    } else if (d.conditionType === "BROWSER") {
      if (d.browserConditionParam.replaceDatas) {
        const ids = [];
        const names = [];
        d.browserConditionParam.replaceDatas.forEach(l => {
          ids.push(l.id);
          names.push(l.name);
        });
        obj[d.domkey[0]] = ids.join(",");
        obj[`${d.domkey[0]}span`] = names.join(",");
      }
    } else if (d.conditionType === "INPUTNUMBER") {
      obj[d.domkey[0]] = d.value || "";
    } else if (!d.conditionType) {
      obj = { ...obj, ...getDefaultValues(d, obj) };
    }
  };
  if (typeof datas === "object") {
    if (Object.prototype.toString.call(datas) === "[object Array]") {
      datas.forEach(data => {
        getNewObj(data);
      });
    } else {
      for (const key in datas) {
        if (datas.hasOwnProperty(key)) {
          getNewObj(datas[key]);
        }
      }
    }
  }
  return obj;
};

export const getRequiredKeys = (conditions = [], datas = {}) => {
  let keys = [];
  const getNewKeys = d => {
    if (
      d.conditionType === "BROWSER" &&
      d.browserConditionParam.viewAttr === 3
    ) {
      keys.push(d.domkey[0]);
    } else if (d.conditionType === "TEXTAREA" && d.viewAttr === 3) {
      keys.push(d.domkey[0]);
    } else if (d.conditionType === "INPUT_INTERVAL" && d.viewAttr === 3) {
      if (d.needDefaultValue === false)
        keys.push([d.domkey[0], d.domkey[1], "or"]);
      else keys.push(d.domkey[0], [d.domkey[1], d.domkey[0]]);
    } else if (d.conditionType === "RANGEPICKER" && d.viewAttr === 3) {
      if (d.needDefaultValue === false)
        keys.push([d.domkey[0], d.domkey[1], "or"]);
      else keys.push(d.domkey[0], d.domkey[1]);
    } else if (d.conditionType === "SELECT_LINKAGE") {
      const bDatas = d.selectLinkageDatas[datas[d.domkey[0]]];
      bDatas &&
        bDatas.viewAttr === 3 &&
        keys.push([bDatas.domkey[0], d.domkey[0]]);
    } else if (d.conditionType === "INPUT" && d.viewAttr === 3) {
      keys.push(d.domkey[0]);
    } else if (d.conditionType === "DATEPICKER" && d.viewAttr === 3) {
      keys.push(d.domkey[0]);
    } else if (d.conditionType === "INPUTNUMBER" && d.viewAttr === 3) {
      keys.push(d.domkey[0]);
    } else if (d.conditionType === "SELECT") {
      keys.push(d.domkey[0]);
    } else if (!d.conditionType) {
      keys = keys.concat(getRequiredKeys(d, datas));
    }
  };
  if (typeof conditions === "object") {
    if (Array.isArray(conditions)) {
      conditions.forEach(data => {
        getNewKeys(data);
      });
    } else {
      for (const key in conditions) {
        if (conditions.hasOwnProperty(key)) {
          getNewKeys(conditions[key]);
        }
      }
    }
  }
  return keys;
};

export const getLinkUrls = (datas = []) => {
  let urls = {};
  const getNewObj = d => {
    if (d.conditionType === "SELECT_LINKAGE") {
      if (d.options.filter(op => op.selected).length > 0) {
        const select = d.options.filter(op => op.selected)[0];
        if (d.conditionType === "SELECT_LINKAGE" && select.key) {
          const sDatas = d.selectLinkageDatas;
          const bDatas = sDatas[select.key];
          bDatas && getNewObj(bDatas);
        }
      }
    } else if (d.conditionType === "BROWSER") {
      if (d.browserConditionParam.linkUrl) {
        urls[d.domkey[0]] = d.browserConditionParam.linkUrl;
      }
    }
  };
  if (typeof datas === "object") {
    if (Object.prototype.toString.call(datas) === "[object Array]") {
      datas.forEach(data => {
        getNewObj(data);
      });
    } else {
      for (const key in datas) {
        if (datas.hasOwnProperty(key)) {
          getNewObj(datas[key]);
        }
      }
    }
  }
  return urls;
};



// WEBPACK FOOTER //
// ./ecology9/wea-auth/util.js